module.exports = __webpack_public_path__ + "static/media/fundo1.bc8200d9.jpg";